<template>

  <v-card class="vehicle-status-selector" style="background-color:#080404">
    <!-- Title -->
    <v-card-title class="text-h5 pb-4" style="border-bottom:1px solid #212121;">Assign Vehicle</v-card-title>

    <!-- Vehicle cards -->
    <v-card-text class="px-0 mt-6">
      <v-container fluid v-if="vehicleItems.length > 0">
        <v-row class="mx-2">
          <v-col
              v-for="(vehicle, index) in vehicleItems"
              :key="`vehicle-${index}`"
              :ref="vehicle.id"
              :class="{ active: vehicle.id === selectedVehicle.id }"
              cols="6">
            <vehicle-status-card
                :vehicle="vehicle"
                v-on:itemClicked="setSelectedVehicle(vehicle)" />
          </v-col>
        </v-row>
      </v-container>

      <v-container v-else>
        (No vehicles available)
      </v-container>
    </v-card-text>

    <!-- Actions -->
    <v-card-actions class="mt-2 px-6 py-6" style="border-top:1px solid #212121;">
      <v-btn text color="primary" width="90" @click="emitCancel">
        Cancel
      </v-btn>
      <v-spacer />
      <v-btn large color="primary" width="180" :disabled="!selectedVehicle.id" @click="emitSelection">
        Assign Vehicle
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import VehicleStatusCard from '@/components/vehicles/VehicleStatusCard'

export default {
  name: 'VehicleStatusSelector',

  components: {
    VehicleStatusCard
  },

  props: {
    activeSelected: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      vehicleData: null,
      selectedVehicle: {}
    }
  },

  computed: {
    vehicleItems () {
      return (this.vehicleData) ? this.vehicleData.items : []
    }
  },

  async beforeMount () {
    // Load all available vehicles
    this.vehicleData = await this.$store.dispatch('sh/dataApi', {
      method: 'get',
      uri: 'vehicles',
      opts: {
        params: {
          vehicle_status: ['AT_HQ', 'ON_DELIVERY', 'RETURNING_TO_HQ']
        }
      }
    })

    // Set the active selection (if provided)
    if (this.activeSelected) this.selectedVehicle = this.activeSelected
  },

  methods: {
    emitCancel () {
      this.selectedVehicle = {}
      this.$emit('canceled')
    },

    emitSelection () {
      this.$emit('selected', this.selectedVehicle)
    },

    setSelectedVehicle (vehicle) {
      this.selectedVehicle = vehicle
    }
  }
}
</script>

<style>
  .vehicle-status-selector .active {
    border-radius: 4px;
    border: 2px solid #c9c9c9;
  }
</style>
